export default __webpack_public_path__ + "static/media/pos.e0492560.svg";